import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormItem } from '../form/FormItem';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'vias-file',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.scss']
})
export class FileComponent implements OnInit {
  @Input() item: FormItem;
  @Input() form: FormGroup;
  @Output() onchange: EventEmitter<object> = new EventEmitter<object>();
  constructor() {}
  ngOnInit(): void {}
  onChange($event): void {
    if($event.target.files !== undefined){
      this.onchange.emit($event.target);
    }
  }
}
